import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    loginRequest: ['payload', 'route', 'after'],
    loginSuccess: ['response'],
    loginFailure: null,

    logoutRequest: null,
    logoutSuccess: null,
    logoutFailure: null,

    refreshRequest: null,
    refreshSuccess: null,
    refreshFailure: null,

    getslugRequest: ['slug'],
    getslugSuccess: ['response'],
    getslugFailure: null,

    emailverificationRequest: ['payload', 'callback'],
    emailverificationSuccess: null,
    emailverificationFailure: null,

    getentityconnectionsRequest: ['loading'],
    getentityconnectionsSuccess: ['response'],
    getentityconnectionsFailure: null,

    getauthoringRequest: null,
    getauthoringSuccess: ['response'],
    getauthoringFailure: null,

    getlibraryfiltersRequest: null,
    getlibraryfiltersSuccess: ['response'],
    getlibraryfiltersFailure: null,

    getusercompaniesRequest: ['userId'],
    getusercompaniesSuccess: ['response'],
    getusercompaniesFailure: null,

    uploadRequest: ['payload', 'callback', 'noToast'],
    uploadSuccess: ['response'],
    uploadFailure: null,

    getcompaniesRequest: null,
    getcompaniesSuccess: ['response'],
    getcompaniesFailure: null,

    getcompanyRequest: ['companyId'],
    getcompanySuccess: ['response'],
    getcompanyFailure: null,

    posteditprofileRequest: ['userId', 'payload'],
    posteditprofileSuccess: ['response'],
    posteditprofileFailure: null,

    postcompanyusersRequest: ['payload', 'companyId', 'after', 'callback'],
    postcompanyusersSuccess: ['response'],
    postcompanyusersFailure: null,

    // Bell Notifications
    fetchnotificationsRequest: ['payload'],
    fetchnotificationsSuccess: ['response'],
    fetchnotificationsFailure: null,

    updatenotificationsRequest: ['id', 'event', 'after', 'route'],
    updatenotificationsSuccess: ['response'],
    updatenotificationsFailure: null,

    getcompanyvendorRequest: ['vendorId'],
    getcompanyvendorSuccess: ['response'],
    getcompanyvendorFailure: null,

    postrecoverypasswordRequest: ['payload'],
    postrecoverypasswordSuccess: ['response'],
    postrecoverypasswordFailure: null,

    postmulticompanydataRequest: ['payload'],
    postmulticompanydataSuccess: ['response'],
    postmulticompanydataFailure: null,

    postmulticompanyemployeesRequest: ['payload', 'loading'],
    postmulticompanyemployeesSuccess: ['response'],
    postmulticompanyemployeesFailure: null,

    getallauthorsRequest: null,
    getallauthorsSuccess: ['response'],
    getallauthorsFailure: null,

    postsaveauthorRequest: ['payload', 'callback'],
    postsaveauthorSuccess: ['response'],
    postsaveauthorFailure: null,

    postsavebusinessauthorRequest: ['payload', 'callback'],
    postsavebusinessauthorSuccess: ['response'],
    postsavebusinessauthorFailure: null,

    postdeleteauthorRequest: ['payload', 'callback'],
    postdeleteauthorSuccess: ['response'],
    postdeleteauthorFailure: null,

    getcommunityusersRequest: ['userId'],
    getcommunityusersSuccess: ['response'],
    getcommunityusersFailure: null,

    getemployeesearchRequest: ['payload', 'loading'],
    getemployeesearchSuccess: ['response'],
    getemployeesearchFailure: null,

    getuserjobdescriptionRequest: null,
    getuserjobdescriptionSuccess: ['response'],
    getuserjobdescriptionFailure: null,

    getuserhealthplanRequest: ['userId'],
    getuserhealthplanSuccess: ['response'],
    getuserhealthplanFailure: null,

    modalRequest: ['payload'],
    advancedsearchRequest: ['tags', 'target', 'published', 'tracking'],
    globalfilterRequest: ['companies', 'employees'],
    selectprojectRequest: ['id'],
    updateloginuserRequest: ['user'],
    onprofilepageRequest: ['target'],

    resetRequest: null,

    // Clear all caches
    clearRequest: null,
});

export const AppTypes = Types;
export default Creators;
